import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { setSaveWithPanelColorState } from 'store/slices/ToolSlice';
import SwitchToggle from 'components/Basic/SwitchToggle/SwitchToggle';
export default function SaveWithPanelColorToggle () {
	const { saveWithPanelColor, editModeEnabled, hideSatelliteOverlay } = useSelector((state: RootState) => state.toolNewPostions.data);

	const dispatch = useDispatch<AppDispatch>();
	const queriesRunningInBackGround = useQueriesRunningInBackGround();

	const handleClick = () => {
		dispatch(setSaveWithPanelColorState({ enabled: !saveWithPanelColor }));
	};

	if(editModeEnabled) {
		return null;
	}
	
	return (
		<div className='switchButton showPanel'>
			<span>Show panels with color</span>
			<SwitchToggle 
				checked={saveWithPanelColor}
				onChange={handleClick}
				disabled={queriesRunningInBackGround || hideSatelliteOverlay}
				className='showpanel-toggle'
			/>
		</div>
	);
}